import { render, staticRenderFns } from "./PageUserPublic.vue?vue&type=template&id=66920697&scoped=true&"
import script from "./PageUserPublic.vue?vue&type=script&lang=js&"
export * from "./PageUserPublic.vue?vue&type=script&lang=js&"
import style0 from "./PageUserPublic.vue?vue&type=style&index=0&id=66920697&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66920697",
  null
  
)

export default component.exports